import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import withRouter from 'src/utils/withRouter';
import { useIdleTimer } from 'react-idle-timer';
import { INIT_COUNT, IDLE_TIMEOUT, LOGOUT_URL } from 'src/constants/constants.js';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { connect } from 'react-redux';

import { checkStatusPending } from 'src/ui/features/Messaging/state/messagingActions';

const IdleTimerBridge = ({ children, onIdle, setIdleTimer, timeout }) => {
  const idleTimer = useIdleTimer({ onIdle, timeout });

  React.useEffect(() => {
    setIdleTimer(idleTimer);
  }, [idleTimer, setIdleTimer]);

  return children;
};

class LayoutContainer extends React.Component {
  idleTimer = null;
  state = {
    expiryDialog: {
      open: false,
    },
    count: INIT_COUNT,
    timeout: IDLE_TIMEOUT,
  };
  secondsRemaining;
  intervalHandle;
  timeOutHandle;
  countdownDeadline;

  componentDidMount() {
    document.addEventListener('visibilitychange', this.syncCountdownWithDeadline);
    window.addEventListener('focus', this.syncCountdownWithDeadline);
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.syncCountdownWithDeadline);
    window.removeEventListener('focus', this.syncCountdownWithDeadline);
    this.clearCountdownTimers();
  }

  tick = () => {
    this.syncCountdownWithDeadline();
  };
  getSecondsRemaining = () => {
    if (!this.countdownDeadline) {
      return INIT_COUNT;
    }

    return Math.max(0, Math.ceil((this.countdownDeadline - Date.now()) / 1000));
  };
  syncCountdownWithDeadline = () => {
    if (!this.state.expiryDialog.open || !this.countdownDeadline) {
      return;
    }

    const count = this.getSecondsRemaining();

    if (count <= 0) {
      this.setState({ count: 0 }, this.clearIntervalHandle);
      return;
    }

    if (count !== this.state.count) {
      this.setState({ count });
    }
  };
  clearCountdownTimers = () => {
    clearInterval(this.intervalHandle);
    clearTimeout(this.timeOutHandle);
    this.intervalHandle = undefined;
    this.timeOutHandle = undefined;
    this.countdownDeadline = undefined;
  };
  clearIntervalHandle = () => {
    this.clearCountdownTimers();
    this.props.history.push(LOGOUT_URL);
  };
  _onIdle = e => {
    this.idleTimer.pause();

    this.toggleModal();
    this.startCountdown();
  };
  setIdleTimer = idleTimer => {
    this.idleTimer = idleTimer;
  };
  startCountdown = () => {
    this.clearCountdownTimers();
    this.countdownDeadline = Date.now() + INIT_COUNT * 1000;
    this.setState({ count: INIT_COUNT });
    this.intervalHandle = setInterval(this.tick, 1000);
    /* Keep logout tied to real elapsed time even when browser throttles background tabs. */
    this.timeOutHandle = setTimeout(() => {
      this.tick();
    }, INIT_COUNT * 1000 + 1000);
  };
  toggleModal = () => {
    /* */
    this.setState({
      expiryDialog: {
        open: !this.state.expiryDialog.open,
      },
    });
  };
  _onCancel = () => {
    /* */
    this.toggleModal();
    this.clearCountdownTimers();
    this.props.history.push(LOGOUT_URL);
    sessionStorage.setItem('token', null);
    sessionStorage.setItem('userInfo', {});
  };
  _onConfirm = () => {
    /* */
    this.toggleModal();
    this.clearCountdownTimers();
    this.idleTimer.reset();
    this.setState({
      count: INIT_COUNT,
    });
  };
  render() {
    return (
      <Fragment>
        <IdleTimerBridge setIdleTimer={this.setIdleTimer} timeout={this.state.timeout} onIdle={this._onIdle}>
          {this.props.children}
        </IdleTimerBridge>
        <ConfirmDialog
          open={this.state.expiryDialog.open}
          title={intl.get('global.expiryMessage.title')}
          cancelText={intl.get('global.expiryMessage.cancelText')}
          confirmText={intl.get('global.expiryMessage.confirmText')}
          onCancel={this._onCancel}
          onConfirm={this._onConfirm}>
          <span>{intl.get('global.expiryMessage.text', { val: `${this.state.count}` })}</span>
        </ConfirmDialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: state.login.userInfo,
});

const mapDispatchToProps = {
  checkStatusPending,
};

const LayoutContainerWithRouter = withRouter(LayoutContainer);

export default connect(mapStateToProps, mapDispatchToProps)(LayoutContainerWithRouter);
